import type * as React from 'react';

import { Helmet } from '@xing-com/crate-helmet';

type BusinessHeadProps = {
  title: string;
  description: string;
  url?: string;
};

export const BusinessHead: React.FC<BusinessHeadProps> = ({
  title,
  description,
  url,
}) => {
  const finalUrl = `https://www.xing.com/business-solutions/${url || ''}`;

  return (
    <Helmet>
      <meta property="og:url" content={finalUrl}></meta>
      <link rel="canonical" href={finalUrl} />

      <title>{title} | XING</title>
      <meta property="og:title" content={`${title} | XING`} />
      <meta name="twitter:title" content={`${title} | XING`}></meta>

      <meta name="description" content={description} />
      <meta property="og:description" content={description}></meta>
      <meta name="twitter:description" content={description}></meta>

      <meta name="robots" content="index,follow" />
    </Helmet>
  );
};
